import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "./LoginSignUp.css";
import Header from "../../Header/Navbar";
import { FaLock } from "react-icons/fa6";
import SocialLogin from "../../SocialMedia/SocialMedia";
import { FormData } from "../../../Interface/Login.interface";
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../../Action/auth.Action'
import type { AppDispatch } from '../../../App/store';
import { getStoredAuth } from "../../../StoreData/authUser";





const LoginSignUp: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [formData, setFormData] = useState<FormData>({ username: "", password: "" });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [activeTab, setActiveTab] = useState<string>("tabButton2");


  const navigate = useNavigate();

useEffect(() => {
  const stored = getStoredAuth();

  try {
    const data = JSON.parse(stored);
    if (Array.isArray(data) && data.length > 0) {
      navigate('/'); 
    }
  } catch (err) {
    console.error('Failed to parse stored auth:', err);
  }
}, []);

  const validateField = (name: string, value: string): string => {
    if (name === "username") {
      if (!value) return "Email or phone number is required.";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[0-9]{10}$/;

      if (!emailRegex.test(value) && !phoneRegex.test(value)) {
        return "Enter a valid email or 10-digit phone number.";
      }
    }


    return "";
  };
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    const errorMsg = validateField(name, value);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMsg }));
  };

  const handleLogin = async (event: FormEvent<HTMLFormElement>) => {
    
    event.preventDefault();

    const newErrors: { [key: string]: string } = {};
    Object.entries(formData).forEach(([key, value]) => {
      const error = validateField(key, value);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fix validation errors.");
      return;
    }

    try {

      await dispatch(loginUser(formData));

      const auth = getStoredAuth();

      // Check if auth is falsy or an empty array string
      if (!auth || auth === "[]") {
        toast.error("Wrong credentials!");
      } else {
        toast.success("Login successful!");
        navigate('/');
      }
    } catch (error) {
      toast.error("Login failed. Try again.");
    }
  };


  const handleTab = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <>
      <Toaster />
    

      <div className="loginSignUpSection">
        <div className="loginSignUpContainer">
          <div className="loginSignUpTabs">
            <p
              onClick={() => handleTab("tabButton2")}
              className={activeTab === "tabButton2" ? "active" : ""}
            >
              <FaLock size={20} style={{ marginRight: "8px" }} />
              Account Login
            </p>
          </div>

          <div className="loginSignUpTabsContent">
            {activeTab === "tabButton2" && (
              <div className="loginSignUpTabsContentLogin">
                <form onSubmit={handleLogin} noValidate>
                  <input
                    type="text"
                    name="username"
                    placeholder="Email or Phone Number *"
                    value={formData.username}
                    onChange={handleOnChange}
                  />
                  {errors.username && <small className="error">{errors.username}</small>}

                  <input
                    type="password"
                    name="password"
                    placeholder="Password *"
                    value={formData.password}
                    onChange={handleOnChange}
                  />

                  <div className="loginSignUpForgetPass">
                    <p>
                      <Link to="/resetPassword">Forgot Password?</Link>
                    </p>
                    <p>
                      Need an Account? <Link to="/RegisterForm">Register</Link>
                    </p>
                  </div>

                  <button type="submit">
                    <FaLock size={20} style={{ marginRight: "8px" }} />
                    Log In
                  </button>
                </form>

                <SocialLogin />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginSignUp;
